import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';

import CustomDropDown from '../dropdown/CustomDropDown';
import CustomIcon from '../CustomIcon';
import routerHistory from '../../../routerHistory';

import * as classroomActions from '../../../actions/classroom/classroomActions';
import * as componentActions from '../../../actions/componentActions';
import { PLATFORM_DEFAULT, ROLE, ROUTES, TABS_CONSTANTS_TRANSLATIONS } from '../../../const';
import ClassCodeReveal from '../reveal/ClassCodeReveal';
import { getClassroomImage } from '../../../services/assets/assetsService';
import { prettyName } from '../../../utils/stringUtils';

const DEFAULT_PLAIN_BACKGROUND = 'plain';
const LOADED_PLAIN_BACKGROUND = 'plain loaded';

class MenuHeader extends React.Component {
  state = {
    image: '',
    plainBackground: DEFAULT_PLAIN_BACKGROUND
  };

  componentDidUpdate(prevProps) {
    const { classroomPicture } = this.props;
    if (classroomPicture !== prevProps.classroomPicture) this.menuImage.className = '';
  }

  backgroundLoadHandler = () => {
    this.backgroundImg.className = `${this.backgroundImg.className} loaded`;
  };

  getDropDownOptions = () => {
    return [
      {
        id: 1,
        name: I18n.t('leftMenu.classcode'),
        action: this.openClassCodeReveal,
        class: 'link',
        icon: <CustomIcon name="television-screen" size={16} />,
        disabledOffline: false
      }
    ];
  };

  openClassCodeReveal = () => {
    const { classroomActions } = this.props;
    classroomActions.setClassCodePopupOpen(true);
  };

  getBackGroundImage = () => {
    const { headerImage } = this.props;
    return (
      <img
        ref={ref => (this.backgroundImg = ref)}
        className="menu-header-background"
        src={headerImage}
        alt="presentation"
        onLoad={this.backgroundLoadHandler}
      />
    );
  };

  renderBackground = () => {
    const { classroomColour, inClassroom, colors } = this.props;

    let classroomBackgroundStyle;
    if (classroomColour && inClassroom) {
      classroomBackgroundStyle = { backgroundColor: colors[`classroom0${classroomColour}`] };
    }

    if (inClassroom) {
      this.plainBackground = !classroomColour ? DEFAULT_PLAIN_BACKGROUND : `${LOADED_PLAIN_BACKGROUND}`;

      return (
        <div className={this.plainBackground} style={classroomBackgroundStyle}>
          &nbsp;
        </div>
      );
    }
    return <div className="gradient">{this.getBackGroundImage()}</div>;
  };

  renderImage = () => {
    const {
      classroomPicture,
      selectedClassroom,
      classroomAsset,
      inClassroom,
      smallLogo,
      classroomsImages
    } = this.props;

    if (inClassroom) {
      if (classroomAsset || (classroomPicture && classroomsImages)) {
        this.image = getClassroomImage(classroomsImages, selectedClassroom, classroomAsset, classroomPicture);
      }
    } else {
      if (smallLogo) {
        this.image = smallLogo;
      }
    }
    return (
      <div className="menu-header-image">
        <img ref={ref => (this.menuImage = ref)} src={this.image} alt="presentation" />
      </div>
    );
  };

  renderTitle = () => {
    const { classroomName, inClassroom, platformName } = this.props;

    const title = inClassroom ? prettyName(classroomName, 26) : platformName || PLATFORM_DEFAULT;

    return <div className="menu-header-title">{title}</div>;
  };

  goToHome = () => {
    this.props.componentActions.setMenuOpen(false);
    routerHistory.push(ROUTES.HOME);
  };

  renderGoBackButton = () => {
    const { layoutSettings, role, inClassroom } = this.props;

    if (!inClassroom) return <div />;

    const userSettings =
      role === ROLE.INSTRUCTOR
        ? layoutSettings.teacherSettings
        : role === ROLE.COINSTRUCTOR
        ? layoutSettings.coinstructorSettings
        : layoutSettings.studentSettings;

    let homeName = I18n.t(TABS_CONSTANTS_TRANSLATIONS[userSettings.userSections.menuRoutes[0]]);
    if (userSettings.userSections.homeTabs.length === 1) {
      const hiddenHomeTab = userSettings.userSections.homeTabs[0];
      homeName = I18n.t(TABS_CONSTANTS_TRANSLATIONS[hiddenHomeTab]);
    }

    return (
      <div className="menu-header-goback" onClick={this.goToHome}>
        <CustomIcon size={11} name="left-chevron" />
        <span>{homeName}</span>
      </div>
    );
  };

  renderDropDown = () => {
    const { classroomId, inClassroom, role } = this.props;
    if (!inClassroom || role === ROLE.STUDENT) return;
    return (
      <div className="menu-header-drop-down">
        <CustomDropDown id={classroomId} optionItems={this.getDropDownOptions()} />
      </div>
    );
  };

  render() {
    const { enableCreateClass } = this.props;
    return (
      <div className="menu-header">
        {this.renderBackground()}
        <div className="menu-header-content">
          {this.renderGoBackButton()}
          {this.renderImage()}
          {this.renderTitle()}
          {enableCreateClass ? this.renderDropDown() : undefined}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuHeader);

MenuHeader.propTypes = {
  platformName: PropTypes.string,
  classroomId: PropTypes.string,
  classroomName: PropTypes.string,
  classroomPicture: PropTypes.string,
  classroomColour: PropTypes.number,
  colors: PropTypes.object,
  classroomActions: PropTypes.object,
  headerImage: PropTypes.string,
  inClassroom: PropTypes.any,
  smallLogo: PropTypes.string,
  classroomsImages: PropTypes.object,
  layoutSettings: PropTypes.object,
  role: PropTypes.string,
  componentActions: PropTypes.object,
  selectedClassroom: PropTypes.object,
  classroomAsset: PropTypes.string,
  enableCreateClass: PropTypes.bool
};

function mapStateToProps(state) {
  const { logo } = state.school.school;
  return {
    platformName: state.account.configuration.platformName,
    classroomId: state.classrooms.selectedClassroom.classroom.id,
    classroomName: state.classrooms.selectedClassroom.classroom.name,
    classroomAsset: state.classrooms.selectedClassroom.classroom.asset,
    classroomPicture: state.classrooms.selectedClassroom.classroom.picture,
    selectedClassroom: state.classrooms.selectedClassroom.classroom,
    classroomColour: state.classrooms.selectedClassroom.classroom.colour,
    role: state.classrooms.selectedClassroom.classroom.role,
    enableEnrollment: state.account.configuration.enableEnrollment,
    enableCreateClass: state.account.configuration.enableCreateClass,
    smallLogo: logo || state.theme.images.logos.small,
    classroomsImages: state.theme.images.classrooms,
    headerImage: state.theme.images.headers.menu,
    colors: state.theme.colors,
    layoutSettings: state.theme.layoutSettings,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    componentActions: bindActionCreators(componentActions, dispatch)
  };
}
